import { Gap } from '../../components/layout';
import React from 'react';
import { Button } from 'react-covideo-common';
import { RECORDING_STATUS } from './types';
import { MdMovie } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
interface RecordingControlProps {
  status: RECORDING_STATUS;
  handleGoToRecordHome: () => void;
  teleprompterActions?: React.ReactNode;
}

export const RecordingHeaderWithRouteGuard = ({
  status,
  handleGoToRecordHome,
  teleprompterActions,
}: RecordingControlProps) => {
  const { t } = useTranslation();
  const shouldHideChangeRecordingOptionBtn =
    status === RECORDING_STATUS.RECORDING || status === RECORDING_STATUS.PAUSED;

  return (
    <>
      <Gap m='72px 0 32px 0' width='100%' justifyContent='space-between'>
        {!shouldHideChangeRecordingOptionBtn ? (
          <Button
            icon={<MdMovie opacity={1} size={18} />}
            variant='secondary'
            text={t('Change recording option')}
            onClick={handleGoToRecordHome}
            disabled={status === RECORDING_STATUS.COUNTDOWN}
          />
        ) : (
          <div style={{ height: 40 }}></div>
        )}
        {teleprompterActions}
      </Gap>
    </>
  );
};
